/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_SerieInputs */

const fr_add_serie = /** @type {(inputs: Add_SerieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une série`)
};

/**

* @param {Add_SerieInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const add_serie = /** @type {((inputs?: Add_SerieInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_SerieInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_add_serie(inputs)
});